import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { showErrorMessage } from '~/domain/utils';

export const useUpdateCandidateStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: PermanentJobsService.updateCandidateStatus,
    onError(error) {
      showErrorMessage({ error });
    },
    onSettled(_, error) {
      if (!error) {
        queryClient.invalidateQueries({ queryKey: ['GET_CANDIDATE_LIST'] });
      }
    },
  });
};
